<!-- 选择 医生的下拉组件 -->
<template>
  <el-select
    v-model="val"
    filterable
    placeholder="请选择医生"
    @change="handleSelect"
    style="width: 100%">
    <el-option
      :label="item.realName"
      :value="item.doctorId"
      v-for="item in options"
      :key="item.id">
    </el-option>
  </el-select>
</template>

<script>
  import api from '@/common/api';

  export default {
    name: 'doctorsSelector',
    data() {
      return {
        val: '',
        options: []
      };
    },
    created() {
      this.getDoctors();
    },
    methods: {
      getDoctors() {
        api.queryStaff({ ifOp: true, pageIndexOnView: 1, pageSize: 100, pageIndex: 0 })
          .then(({ items }) => {
            if (Array.isArray(items)) {
              this.options = items;
            }
          });
      },
      handleSelect() {
        this.$emit('input', this.val);
        const doctor = this.options.find((o) => o.doctorId === this.val);
        this.$emit('change', doctor.account);
      }
    }
  };
</script>
